import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DownloadIcon from 'components/v2/icons/DownloadIcon';
import CargomaticInput from 'components/v2/input';
import LoadingCircle from 'components/ui/LoadingCircle';
import { Popover, Transition } from '@headlessui/react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { sluggify } from 'utils/localization/utils';
const columnMapping = {
    SHIPMENT: 'Shipment',
    EQUIPMENT: 'Equipment',
    SHIPPER: 'Shipper',
    CARRIER: 'Carrier',
    ACCESSORIAL_TYPE: 'Accessorial Type',
    SHIPPER_COST: 'Shipper Cost',
    CARRIER_COST: 'Carrier Cost',
    REASON_CODE: 'Reason Code',
    PAYEE: 'Payee',
    ACTION_REQUIRED: 'Action Required',
    APPROVAL_DUE_DATE: 'Approval Due Date',
    ORIGIN_ADDRESS: 'Origin Address',
    DESTINATION_ADDRESS: 'Destination Address',
    DELIVER_AFTER: 'Deliver After',
    DELIVER_BY: 'Deliver By',
    SHIPPER_STATUS: 'Shipper Status',
    CARRIER_STATUS: 'Carrier Status',
    LAST_UPDATED: 'Last Updated',
};
const ExportAccessorialExceptionCSV = ({ exportCSV, className, exportAccessorialsToCSV, }) => {
    const { t } = useTranslation();
    const [selectedColumns, setSelectedColumns] = useState([
        ...Object.keys(columnMapping),
    ]);
    const handleColumnSelect = (key) => {
        const newSelectedColumns = [...selectedColumns];
        if (newSelectedColumns.includes(key)) {
            newSelectedColumns.splice(newSelectedColumns.indexOf(key), 1);
        }
        else {
            newSelectedColumns.push(key);
        }
        setSelectedColumns(newSelectedColumns);
    };
    const handleSelectAll = () => {
        if (selectedColumns.length === Object.keys(columnMapping).length) {
            return handleDeSelectAll();
        }
        setSelectedColumns(Object.keys(columnMapping));
    };
    const handleDeSelectAll = () => {
        setSelectedColumns([]);
    };
    const handleExport = () => {
        exportAccessorialsToCSV(selectedColumns);
    };
    const popperButtonClassNames = classNames({
        relative: true,
        button: true,
        'button-hollow-green': true,
        'hover:bg-white': !exportCSV,
    });
    return (React.createElement(Popover, { className: "relative" }, ({ open, close }) => (React.createElement(React.Fragment, null,
        React.createElement(Popover.Button, { disabled: !exportCSV, className: popperButtonClassNames },
            exportCSV && (React.createElement("div", { className: "flex items-center space-x-1" },
                React.createElement("span", null, t('EXPORT_CSV')),
                React.createElement(DownloadIcon, null))),
            !exportCSV && (React.createElement(LoadingCircle, { text: t('EXPORTING_CSV'), size: 1, color: "teal-500", textColor: "teal-500" }))),
        React.createElement(Popover.Overlay, null),
        React.createElement(Transition, { show: open, enter: "transition ease-out duration-200", enterFrom: "opacity-0 translate-y-1", enterTo: "opacity-100 translate-y-0", leave: "transition ease-in duration-150", leaveFrom: "opacity-100 translate-y-0", leaveTo: "opacity-0 translate-y-1" },
            React.createElement(Popover.Panel, { static: true, className: "absolute left-0 z-10 h-auto w-44 px-4 mt-3 sm:px-0" },
                React.createElement("div", { className: "rounded-lg shadow-lg p-2 bg-white" },
                    React.createElement("div", { className: "dropdown-filter min-w-100 mb-2" },
                        React.createElement("div", { key: "Select All Columns Header", className: "checkbox-wrapper" },
                            React.createElement(CargomaticInput, { id: "Select All Columns", key: "Select All Columns", label: t('SELECT_ALL_COLUMNS'), type: "checkbox", checked: selectedColumns.length ===
                                    Object.keys(columnMapping).length, disabled: !exportCSV, onChange: handleSelectAll })),
                        React.createElement("hr", { className: "m-0 my-1" }),
                        Object.keys(columnMapping).map((key) => (React.createElement("div", { key: key, className: "checkbox-wrapper" },
                            React.createElement(CargomaticInput, { id: key, key: key, label: key === 'SHIPMENT'
                                    ? titleize(t(key, { count: 1 }))
                                    : titleize(t(sluggify(columnMapping[key]))), type: "checkbox", checked: selectedColumns.includes(key), disabled: !exportCSV, onChange: () => handleColumnSelect(key) }))))),
                    React.createElement("div", { className: "flex justify-start items-center gap-x-2" },
                        React.createElement("button", { className: "button button-green text-xs p-2", onClick: () => {
                                handleExport();
                                close();
                            }, disabled: !exportCSV }, titleize(t('DOWNLOAD'))),
                        React.createElement("button", { className: "button button-red text-xs p-2", onClick: handleDeSelectAll, disabled: !exportCSV }, t('CLEAR_ALL'))))))))));
};
ExportAccessorialExceptionCSV.propTypes = {
    exportCSV: PropTypes.bool.isRequired,
    className: PropTypes.string.isRequired,
    exportAccessorialsToCSV: PropTypes.func.isRequired,
};
export default ExportAccessorialExceptionCSV;
